import styled from 'styled-components';

export const StyledWrapper = styled.div(
  ({ theme }) => `
    .payroll-month-selector-wrapper {
      margin-top: ${theme.spacing[6]}px;
      margin-bottom: ${theme.spacing[6]}px;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: ${theme.spacing[4]}px;
      label {
        width: 120px;
      }
    }
    .month-selector {
      margin-bottom: 0;
      margin-left: 2px;
    }
    .arrear-days-text-input {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: ${theme.spacing[4]}px;
      label {
        width: 120px;
      }
    }
    .tooltip-custom {
      background-color: ${theme.colors.popup.background.intense};
      margin-left: -${theme.spacing[6]}px;
    }
    .arrear-days-tooltip-info-icon {
      position: relative;
      left: -${theme.spacing[6]}px;
    }
  `,
);
